import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Navbar from '../features/Navbar';
import Footer from '../components/Footer';

const ViewSermon = () => {
  const [sermons, setSermons] = useState([]);
  const [filteredSermons, setFilteredSermons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    const fetchSermons = async () => {
      try {
        const response = await fetch('/assets/sermons.json');
        if (!response.ok) {
          throw new Error('Failed to fetch sermons');
        }
        const data = await response.json();
        setSermons(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSermons();
  }, []);

  useEffect(() => {
    // Filter sermons for the selected date
    const formattedDate = selectedDate.toISOString().split('T')[0]; // Format selected date to YYYY-MM-DD
    const todaysSermons = sermons.filter((sermon) => sermon.date === formattedDate);

    // If no sermons for the selected date, use the latest sermon
    if (todaysSermons.length === 0 && sermons.length > 0) {
      const latestSermon = sermons.reduce((latest, current) =>
        new Date(current.date) > new Date(latest.date) ? current : latest
      );
      setFilteredSermons([latestSermon]);
    } else {
      setFilteredSermons(todaysSermons);
    }
  }, [sermons, selectedDate]);

  if (loading) {
    return <p className="text-center text-lg font-semibold text-purple-900">Loading sermons...</p>;
  }

  if (error) {
    return <p className="text-center text-lg font-semibold text-red-600">Error: {error}</p>;
  }

  return (
    <div>
      <Navbar />
      <div className="p-8 bg-gray-100 min-h-screen">
        <h1 className="text-4xl font-bold text-center mb-8 text-purple-900">View Sermons</h1>

        <div className="flex justify-center mb-8">
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            className="text-lg p-2 border rounded-md shadow-md"
            dateFormat="yyyy-MM-dd"
          />
        </div>

        <div className="space-y-6">
          {filteredSermons.map((sermon, index) => (
            <div key={index} className="bg-white p-4 rounded-lg shadow-md">
              <h2 className="text-xl font-bold text-purple-900 mb-4">{sermon.sermonTitle}</h2>
              <p className="text-lg text-gray-600">Preacher: {sermon.preacherName}</p>
              <p className="text-gray-600 text-lg">Date: {sermon.date}</p>
              <p className="text-gray-600 mb-8 text-lg">Text: {sermon.text}</p>
              <p className="mt-2 text-lg text-gray-800">{sermon.content}</p>
              <p className="mt-2 text-lg text-gray-800">{sermon.question}</p>
              <p className="mt-2 text-lg text-gray-800">{sermon.answer}</p>
              <p className="text-xl font-bold text-gray-800 mt-4 mb-4">{sermon.ask}</p>
              <ul className="list-disc ml-5 text-gray-800 space-y-2">
                {Object.keys(sermon)
                  .filter((key) => key.startsWith('list'))
                  .map((key) => (
                    <li key={key}>{sermon[key]}</li>
                  ))}
              </ul>
              <ul className="list-disc ml-5">
                <h1 className="text-xl font-bold text-gray-800 mt-4 mb-4">{sermon.conclude}</h1>
                {Object.keys(sermon)
                  .filter((key) => key.startsWith('prayer'))
                  .map((key) => (
                    <li key={key}>{sermon[key]}</li>
                  ))}
              </ul>
              <ul className="list-disc ml-5">
                <h1 className="text-xl font-bold text-gray-800 mt-4 mb-4">Prayer</h1>
                {Object.keys(sermon)
                  .filter((key) => key.startsWith('weekly'))
                  .map((key) => (
                    <li key={key}>{sermon[key]}</li>
                  ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ViewSermon;
